var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMembers(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6624 9.10995C15.9976 9.10995 17.0808 8.02752 17.0808 6.69224C17.0808 5.35697 15.9976 4.27454 14.6624 4.27454",
    stroke: "#6C5DD3",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7742 11.7373C16.1729 11.7648 16.5694 11.8213 16.9597 11.9092C17.5021 12.0154 18.1544 12.2377 18.3867 12.7242C18.5349 13.0359 18.5349 13.3988 18.3867 13.7112C18.1552 14.1978 17.5021 14.4193 16.9597 14.5308",
    stroke: "#6C5DD3",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.24147 9.10995C3.90619 9.10995 2.823 8.02752 2.823 6.69224C2.823 5.35697 3.90619 4.27454 5.24147 4.27454",
    stroke: "#6C5DD3",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.1297 11.7373C3.73095 11.7648 3.3345 11.8213 2.94415 11.9092C2.40179 12.0154 1.74943 12.2377 1.51797 12.7242C1.36901 13.0359 1.36901 13.3988 1.51797 13.7112C1.74866 14.1978 2.40179 14.4193 2.94415 14.5308",
    stroke: "#6C5DD3",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.94813 12.2581C12.6538 12.2581 14.9654 12.6675 14.9654 14.306C14.9654 15.9438 12.6691 16.3685 9.94813 16.3685C7.24167 16.3685 4.93091 15.9591 4.93091 14.3206C4.93091 12.682 7.22716 12.2581 9.94813 12.2581Z",
    stroke: "#6C5DD3",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.94812 9.9208C8.16367 9.9208 6.73291 8.49004 6.73291 6.70483C6.73291 4.92039 8.16367 3.48962 9.94812 3.48962C11.7326 3.48962 13.1633 4.92039 13.1633 6.70483C13.1633 8.49004 11.7326 9.9208 9.94812 9.9208Z",
    stroke: "#6C5DD3",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMembers);
export default __webpack_public_path__ + "static/media/members.653d3b0546da5c13b6e0e760af539ab1.svg";
export { ForwardRef as ReactComponent };